export const STICKY_CASES = [
  'a',
  'A',
  'k',
  'K',
  'v',
  'V',
  've',
  'Ve',
  'o',
  'O',
  'i',
  'I',
  'na',
  'Na',
  'z',
  'Z',
  'za',
  'Za',
  'the',
  'The',
];

export const formatText = text => {
  let tempString = text;
  for (let i = 0; i < STICKY_CASES.length; i += 1) {
    const rex = new RegExp(` ${STICKY_CASES[i]} `, 'g');
    tempString = tempString.replace(rex, ` ${STICKY_CASES[i]}\u00A0`);
  }
  return tempString;
};

export const formatNameText = text => text.replace(/ \(/g, '\u00A0(');



// WEBPACK FOOTER //
// ./src/utils/TextHelper.js